<script setup>
import axios from "axios";
import Swal from "sweetalert2";
import {ref, watch} from "vue";
import {useForm, router} from "@inertiajs/vue3";
import Modal from "@/components/Shared/Modal.vue";
import FormButton from "@/components/Shared/Form/Button.vue";
import FormInput from "@/components/Shared/Form/Input/Index.vue";

const emit = defineEmits(["close"]);

const props = defineProps({
  show: Boolean,
  userIntegrationId: [String, Number],
  userIntegrationFlowId: [String, Number],
  type: String
});

const form = useForm({
  template_id: null,
});

const templates = ref([]);

const load = () => {
  form.processing = true;
  form.clearErrors();
  const data = form.data();

  data.template_id = data.template_id?.id ?? null;

  axios
    .patch(`/api/integrations/${props.userIntegrationId}/flows/${props.userIntegrationFlowId}/templates/${props.type}`, data)
    .then(({data}) => {
      close();

      Swal.fire({
        text: data.message,
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
      });

      router.visit(route(route().current(), route().params));
    })
    .catch(function (error) {
      if (error.response?.status === 422) {
        form.setError(error.response.data.errors);
      } else {
        throw error;
      }
    })
    .finally(() => form.processing = false);
};

const close = () => emit("close");

watch(() => props.show, (newValue) => {
  form.reset();

  if (newValue) {
    axios
      .get(`/api/integrations/${props.userIntegrationId}/flows/${props.userIntegrationFlowId}/templates/${props.type}`)
      .then(({data}) => templates.value = data.data);
  }
});
</script>
<template>
  <modal :show="show" @close="close">
    <template #title>
      {{ trans("Load from template") }}
    </template>
    <template #content>
      <div class="mt-4">
        <form-input
          v-model="form.template_id"
          type="select"
          label-text="Template"
          :options="templates"
          :error="form.errors.template_id"
          group-label="group"
          group-values="templates"
          track-by="id"
          label="title"
          :placeholder="trans('dashboard.integrations.flows.select_an_option')"
        />
      </div>
    </template>
    <template #footer>
      <form-button class="button_cancel" :value="trans('common.cancel')" @click="close"/>

      <form-button class="ml-3"
                   :value="trans('common.add')"
                   :processing="form.processing"
                   @click="load"/>
    </template>
  </modal>
</template>
